<template>
    <div class="video-box">
        <video ref="video" class="video" preload="metadata" :autoplay.sync="isPlay" @mouseenter="play" @mouseleave="stop" >
            <source :src="newUrl">
        </video>
<!--        <p id="img" ref="img" class="img"></p>-->
    </div>
</template>

<script>
import { getVideoFirstImg } from '../../../../utils/utils'

export default {
  name: 'video-box',
  props: {
    url: String,
    index: Number
  },
  watch: {
    url (vl) { this.newUrl = vl },
    newUrl (vl) { this.$emit('update:url', vl) }
  },
  created () {
    this.$nextTick(() => {
      // this.init()
    })
  },
  data () {
    return {
      newUrl: this.url.replace('https', 'http')
    }
  },
  methods: {
    init () {
      const eleVideos = document.querySelectorAll('.video-box .video')
      eleVideos[this.index].src = this.newUrl
      eleVideos[this.index].load()
      eleVideos[this.index].addEventListener('loadeddata', this.getImg)
    },
    play () {
      const video = this.$refs.video
      // console.log('div==>play', this.$refs.video)
      video.play()
    },
    stop () {
      const video = this.$refs.video
      video.pause()
    },
    getImg () {
      const eleVideos = document.querySelectorAll('.video-box .video')
      const eleImgs = document.querySelectorAll('.video-box .img')
      console.log('ddd==>', eleVideos, eleImgs)
      getVideoFirstImg({
        eleVideo: eleVideos[this.index],
        eleTarget: eleImgs[this.index],
        imgWidth: 80,
        imgHeight: 80
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .video-box{
        width: 100%;
        height: 80px;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        background: #f1f1f1;

        &:before{
            content: '';
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
        }

        .video{
            width: 100%;
            height: 100%;
            outline: none;
        }
    }
</style>
